import { render, staticRenderFns } from "./GoodsTags.vue?vue&type=template&id=d5fdda9c&scoped=true"
import script from "./GoodsTags.vue?vue&type=script&lang=js"
export * from "./GoodsTags.vue?vue&type=script&lang=js"
import style0 from "./GoodsTags.vue?vue&type=style&index=0&id=d5fdda9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fdda9c",
  null
  
)

export default component.exports